export const environment = {
  production: false,
  //  apiUrl: 'http://localhost/gemsAdmin/gemsAdmin_be/api/v1/',
  // apiUrl: 'https://dcc.gemsbihar.info/api/api/v1',
  apiUrl: 'https://dcc.gemsbihar.co.in/api/api/v1', //NEW
  //apiUrl: 'https://dev.gemsbihar.info/api/api/v1/',
  //apiUrl: 'https://api.gemsbihar.in/api/v1/',
  emailApiUrl: 'https://dev.mail.ssamt.org/api/v1/',
};
